(window as ZoneGlobalConfigurations).__zone_symbol__PASSIVE_EVENTS = ['wheel', 'mousewheel', 'scroll'];
